import { useCallback, useEffect, useState } from 'react';
import { api } from './api';

const POLL_INTERVAL_MS = 60_000;

// CLI-30 — badge de "Mensajes" en el nav. Vuelve a pedir el conteo al servidor
// (no lo decrementa de forma optimista) para que nunca se desincronice de otra
// pestaña u otro usuario del mismo tenant; mismo patrón que NotificationBell.
export function useSubmissionsUnread() {
  const [unreadCount, setUnreadCount] = useState(0);

  const load = useCallback(() => {
    api.submissions.unreadCount().then((r) => setUnreadCount(r.count)).catch(() => { /* el badge se queda en el último valor conocido */ });
  }, []);

  useEffect(() => {
    load();
    const interval = setInterval(load, POLL_INTERVAL_MS);
    window.addEventListener('submissions:read', load);
    return () => {
      clearInterval(interval);
      window.removeEventListener('submissions:read', load);
    };
  }, [load]);

  return { unreadCount };
}
